import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  getLanguageOptions,
  getSelectedLanguage,
  resolveAccessToken,
  updateLanguage,
} from '@nomiss/services';

export const languageQueryKeys = {
  selected: ['account', 'language', 'selected'] as const,
  options: ['account', 'language', 'options'] as const,
};

export function useSelectedLanguage(
  accessToken?: string | null,
  enabled = true,
) {
  const token = accessToken ?? resolveAccessToken();

  return useQuery({
    queryKey: [...languageQueryKeys.selected, token ?? ''] as const,
    queryFn: () => getSelectedLanguage(),
    enabled: enabled && Boolean(token),
  });
}

export function useLanguageOptions(
  accessToken?: string | null,
  enabled = true,
) {
  const token = accessToken ?? resolveAccessToken();

  return useQuery({
    queryKey: [...languageQueryKeys.options, token ?? ''] as const,
    queryFn: () => getLanguageOptions(),
    enabled: enabled && Boolean(token),
  });
}

export function useUpdateLanguage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (languageId: string) => updateLanguage(languageId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: languageQueryKeys.selected });
      void queryClient.invalidateQueries({ queryKey: languageQueryKeys.options });
    },
  });
}
